/**
 * @generated SignedSource<<f5ca3df3ad4470bc838979b372cc1520>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceEditQuery$variables = {
  piece_id: string;
};
export type PieceEditQuery$data = {
  readonly music_viewer: {
    readonly piece: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PieceEditBody_piece">;
    };
  };
};
export type PieceEditQuery = {
  variables: PieceEditQuery$variables;
  response: PieceEditQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "piece_id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "piece_id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PieceEditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PieceEditBody_piece"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PieceEditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MusicSheet",
                "kind": "LinkedField",
                "name": "sheets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": "noteFinderUserConfirmation",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "step_type",
                        "value": "NOTE_USER_CONFIRMATION"
                      }
                    ],
                    "concreteType": "MusicParseStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": "steps(step_type:\"NOTE_USER_CONFIRMATION\")"
                  },
                  {
                    "alias": "barFinderUserConfirmation",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "step_type",
                        "value": "BAR_FINDER_USER_CONFIRMATION"
                      }
                    ],
                    "concreteType": "MusicParseStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "deleted_mask_storage_names",
                                "storageKey": null
                              }
                            ],
                            "type": "MusicParseStepDataBarFinderUserConfirmation",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "steps(step_type:\"BAR_FINDER_USER_CONFIRMATION\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "196a5672c9eb87bb2bc4cb8d74ff9f0c",
    "id": null,
    "metadata": {},
    "name": "PieceEditQuery",
    "operationKind": "query",
    "text": "query PieceEditQuery(\n  $piece_id: ID!\n) {\n  music_viewer {\n    piece(id: $piece_id) {\n      id\n      ...PieceEditBody_piece\n    }\n  }\n}\n\nfragment PieceEditBody_piece on MusicPiece {\n  id\n  name\n  sheets {\n    id\n    noteFinderUserConfirmation: steps(step_type: NOTE_USER_CONFIRMATION) {\n      id\n      status\n    }\n    barFinderUserConfirmation: steps(step_type: BAR_FINDER_USER_CONFIRMATION) {\n      id\n      status\n      data {\n        __typename\n        ... on MusicParseStepDataBarFinderUserConfirmation {\n          deleted_mask_storage_names\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2bff1fede49dc42f23d299e458d88d0";

export default node;
